import React from 'react';
import { createRoot } from 'react-dom/client';
import './i18n/i18n';
import App from './App';
import 'bootstrap/dist/css/bootstrap.min.css';

const root = createRoot(document.getElementById("root"));
root.render(<App />);